import  { useState } from "react";
import { Link } from "react-router-dom";
import QuoteForm from "./QuoteForm";
const clashDisplay = { fontFamily: "'Clash Display', sans-serif" };
const manrope = { fontFamily: "'Manrope', sans-serif" };

export default function ProductCardSlant({ id, title, image, description, stock }) {
   const [showQuoteForm, setShowQuoteForm] = useState(false);
  return (
    <div className="relative bg-gray-100 rounded-xl p-6 shadow-md flex flex-col items-center text-center">

      {/* Image */}
      <img src={image} alt={title} className="h-32 object-contain mb-4" />

      {/* Title */}
      <h2 className="text-xl font-bold mb-2 text-gray-900" style={clashDisplay}>
        {title}
      </h2>

      {/* Description */}
      <p className="text-lg text-gray-700 mb-4" style={manrope}>
        {description}
      </p>

      {/* Buttons */}
      <div className="flex gap-4 mt-4">
         <button
              className="px-6 py-2 bg-[#158DC1] lg:text-lg sm:text-[16px] text-white rounded-[15px] hover:bg-white hover:text-[#158DC1] transition"
              onClick={() => setShowQuoteForm(true)}
            >
              Devis
            </button>
          {showQuoteForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <QuoteForm
            productName={title}
            onClose={() => setShowQuoteForm(false)}
          />
        </div>
      )}
       <Link
  to={`/produits/${id}`}
  className="px-4 py-2 bg-transparent border-2 lg:text-lg sm:text-[16px] border-[#158DC1] text-[#158DC1] rounded-[15px] hover:bg-[#158DC1] hover:text-white transition"
>
  Détails
</Link>

      </div>
    </div>
  );
}
